import client from '../utils/client';
import { postsUrl } from '../store/constants/api';
import { cookieConstants } from "../store/constants";
import { Cookies } from "react-cookie";

const cookies = new Cookies();

export const postService = {
  postsList,
  addPost,
  getPost,
  updatePost
}

function postsList(pageID, perPage) {
  return client.get(postsUrl + '?page=' + pageID + '&per_page=' + perPage)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function addPost(formDate) {
  return client.post(postsUrl + '/create', formDate)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function getPost(postID) {
  return client.get(postsUrl + '/' + postID + '/show')
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function updatePost(formDate) {
  return client.post(postsUrl + '/update', formDate)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}


function logout() {
  cookies.remove(cookieConstants.TOKEN, { path: "/" });
  cookies.remove(cookieConstants.USER, { path: "/" });
}

function handleResponse(response) {
  response = response.response
  var data = response.data;
  if (!response.ok) {
    if (response.status === 401) {
      logout();
      window.location.reload(true);
    }
    const error = data.errors;
    return Promise.reject(error);
  }

  return data;
}